export const intersection = (...args: any[]): any[] => {
  const [first, ...rest] = args;
  return first.filter((item: any) => rest.flat().includes(item));
};

export const difference = (sourceA: any[], sourceB: any[]): any[] => {
  const source = sourceA.flat().length > sourceB.flat().length ? sourceA.flat() : sourceB.flat();
  const compare = sourceA.flat().length > sourceB.flat().length ? sourceB.flat() : sourceA.flat();
  const delta = source.filter((x) => !compare.includes(x));
  return delta;
};

export const removeDuplicateObjects = (array: any[], param: string = "id") => {
  return array.filter((obj1, i, arr) => arr.findIndex((obj2) => obj2[param] === obj1[param]) === i);
};
